import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { FlowNode } from '../../../types/flowBuilder';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { getNodeColors } from '../utils/nodeColors';

const AISummarizerNode: React.FC<NodeProps> = ({ data, selected }) => {
  const config = data.config || {};
  const colors = getNodeColors('ai_summarizer');
  
  return (
    <div className={`
      px-4 py-3 bg-gradient-to-r ${colors.gradient.from} ${colors.gradient.to}
      border-2 transition-all duration-200 ${
        selected ? `${colors.border.selected} shadow-xl scale-105` : `${colors.border.default} shadow-lg`
      }
      rounded-lg min-w-[200px] max-w-[300px]
    `}>
      <Handle
        type="target"
        position={Position.Left}
        className={`w-3 h-3 bg-white border-2 ${colors.handle}`}
        style={{ left: -6 }}
      />
      
      {/* Header */}
      <div className="flex items-center space-x-3">
        <div className="flex-shrink-0">
          <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
            <DocumentTextIcon className="w-5 h-5 text-white" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className={`text-sm font-semibold ${colors.text.primary} truncate`}>
              AI Összefoglaló
            </h3>
            <span className="px-1.5 py-0.5 text-[10px] font-medium bg-white bg-opacity-30 rounded text-white">
              SUMMARY
            </span>
          </div>
          <p className={`text-xs ${colors.text.secondary} truncate`}>
            Intelligens szöveg összefoglalás
          </p>
        </div>

        {/* Status indicator */}
        <div className="flex-shrink-0">
          <div className={`w-3 h-3 rounded-full ${
            data.hasError ? 'bg-red-500' : 'bg-green-400'
          }`} />
        </div>
      </div>

      {/* Content */}
      <div className="mt-2 space-y-2">
        {config.text && (
          <div className={`text-xs ${colors.text.secondary}`}>
            Szöveg: {config.text.length > 50 ? `${config.text.substring(0, 50)}...` : config.text}
          </div>
        )}
        
        <div className={`flex justify-between text-xs ${colors.text.secondary}`}>
          <span>Hossz: {config.summaryLength || 'medium'}</span>
        </div>
      </div>

      {/* Error message */}
      {data.hasError && data.errorMessage && (
        <div className="mt-2 text-xs text-red-200 bg-red-500 bg-opacity-20 px-2 py-1 rounded">
          {data.errorMessage}
        </div>
      )}

      {/* Execution data preview */}
      {data.executionData && (
        <div className={`mt-2 text-xs ${colors.text.secondary} bg-black bg-opacity-20 px-2 py-1 rounded`}>
          <div className="font-mono">
            {typeof data.executionData === 'object' 
              ? JSON.stringify(data.executionData, null, 2).substring(0, 50) + '...'
              : String(data.executionData).substring(0, 50)
            }
          </div>
        </div>
      )}

      <Handle
        type="source"
        position={Position.Right}
        className={`w-3 h-3 bg-white border-2 ${colors.handle}`}
      />
    </div>
  );
};

export default AISummarizerNode;
